/**
 * Dual-dispatch analytics helper.
 *
 * Forwards each event to:
 *   1) Google Analytics 4 via window.gtag
 *   2) PostHog via window.posthog.capture
 *
 * Both libraries are injected by snippets in public/index.html. They load
 * asynchronously, so this wrapper checks for their availability at call
 * time and silently no-ops when either is missing (ad blocker, dev mode,
 * race during first paint).
 */

const safeGtag = (name, params) => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    try {
        window.gtag("event", name, params);
    } catch (err) {
        console.debug("analytics: gtag dispatch failed", { name, err });
    }
};

const safePosthog = (name, params) => {
    if (typeof window === "undefined") return;
    if (!window.posthog || typeof window.posthog.capture !== "function") return;
    try {
        window.posthog.capture(name, params);
    } catch (err) {
        console.debug("analytics: posthog capture failed", { name, err });
    }
};

export const trackEvent = (name, params = {}) => {
    safeGtag(name, params);
    safePosthog(name, params);
};

/**
 * Associate the visitor's PostHog distinct id with a stable id (typically
 * the email they just signed up with) so future events on the same browser
 * land on the same person profile. Called after waitlist submission.
 */
export const identifyPerson = (distinctId, properties = {}) => {
    if (typeof window === "undefined") return;
    if (!distinctId) return;
    if (!window.posthog || typeof window.posthog.identify !== "function") return;
    try {
        window.posthog.identify(distinctId, properties);
    } catch (err) {
        console.debug("analytics: posthog identify failed", { distinctId, err });
    }
};
